import { render } from "./authCheck.vue?vue&type=template&id=d63f708a"
import script from "./authCheck.vue?vue&type=script&lang=js"
export * from "./authCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__